import React from 'react'

import styles from './styles.module.scss'

const CoordinatedArrivalSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.columns}>
          <div className={styles.copyColumn}>
            <h3 className={styles.heading}>Coordinated Arrival, Handled with Care</h3>
            <p className={styles.body}>
              For families traveling from out of the area, we coordinate every detail of arrival.
              Whether your loved one arrives by air or is brought by family, in a casket or an urn,
              they are received with dignity and prepared for services at Arlington. We can meet
              arrivals at the airport, bring your loved one into our care, and coordinate with your
              family and local funeral director to ensure everything is in place.
            </p>
            <p className={styles.body}>
              When Arlington scheduling timelines extend, we also provide secure, dignified
              sheltering for caskets and urns until services can take place, offering continuity and
              peace of mind throughout the process.
            </p>

            <h4 className={styles.subheading}>Professional Videography Services</h4>
            <p className={styles.body}>
              For families who wish to document the service or share it with loved ones who cannot
              attend, videography services are available for Arlington ceremonies. We can help
              connect you with trusted professionals familiar with Arlington National Cemetery
              services, including{' '}
              <a
                href="https://www.mattoxphotographyanc.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mattox Photography ANC
              </a>
              .
            </p>
          </div>

          <div className={styles.imageColumn}>
            <img
              src="/veteran-services/anc.jpg"
              alt="Arlington National Cemetery with cherry blossoms"
              className={styles.image}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default CoordinatedArrivalSection
